import { render, staticRenderFns } from "./preview-shipment.vue?vue&type=template&id=2e787d80&scoped=true&"
import script from "./preview-shipment.vue?vue&type=script&lang=js&"
export * from "./preview-shipment.vue?vue&type=script&lang=js&"
import style0 from "./preview-shipment.vue?vue&type=style&index=0&id=2e787d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e787d80",
  null
  
)

export default component.exports